export enum EApiPaths {
    DELIVERY_PARTNER = '/delivery-partner',
}
